import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { UtilisateurForDropdownModel } from '../../models/UtilisateurForDropdownModel';
import { ConfigurationService } from '../../services/configuration.service';
import { GuidService } from '../../services/guid.service';
import { UtilisateurApiService } from '../../web-api-services/utilisateur.service';

@Component({
  selector: 'utilisateur-dropdown',
  templateUrl: './utilisateur-dropdown.component.html',
  styleUrls: ['./utilisateur-dropdown.component.css'],
})
export class UtilisateurDropdownComponent implements OnInit {
  @Input() editMode: boolean = true;
  @Input() showClear: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() placeholder: string = '';
  @Input() siteId: number = -1;
  @Input() etablissementId: number = -1;
  @Input() showAll: boolean = false;
  pDropdownStyle: any = {};
  panelStyle: any = {};
  minWidth: string = '200px';

  private _utilisateurId: number;
  @Input()
  set utilisateurId(value: number) {
    this._utilisateurId = value;
    this.selectUtilisateur();
  }
  get utilisateurId(): number {
    return this._utilisateurId;
  }

  _utilisateur: UtilisateurForDropdownModel = null;
  @Input()
  set utilisateur(value: UtilisateurForDropdownModel) {
    this._utilisateur = value;
  }
  get utilisateur(): UtilisateurForDropdownModel {
    return this._utilisateur ? this._utilisateur : null;
  }

  @Output() utilisateurIdChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() utilisateurChange: EventEmitter<UtilisateurForDropdownModel> = new EventEmitter<UtilisateurForDropdownModel>();

  public utilisateurs: UtilisateurForDropdownModel[] = [];
  public guid: string;
  public utilisateursLoaded: boolean = false;

  constructor(
    configurationService: ConfigurationService,
    private guidService: GuidService,
    private utilisateurApiService: UtilisateurApiService,
  ) {
    this.pDropdownStyle = { ...configurationService.pDropdownStyle, 'min-width': this.minWidth };
    this.panelStyle = { 'min-width': '600px' };
  }

  ngOnInit() {
    this.guid = this.guidService.newGuid();
    if (!this.utilisateursLoaded) {
      this.loadUtilisateurs();
    } else {
      this.selectUtilisateur();
    }
  }

  selectUtilisateur() {
    if (this.utilisateursLoaded) {
      setTimeout(() => {
        this.utilisateur = this.utilisateurs.find(t => this._utilisateurId != null && this._utilisateurId != undefined && t.Id == this._utilisateurId);
      });
    }
  }

  loadUtilisateurs() {
    this.utilisateurApiService.getUtilisateursForDropdown(this.showAll ? 0 : this.etablissementId || 0, this.showAll ? 0 : this.siteId || 0).subscribe(utilisateurs => {
      this.utilisateurs = utilisateurs;
      this.utilisateursLoaded = true;
      this.selectUtilisateur();
    });
  }

  utilisateurChanged() {
    if (this.utilisateursLoaded) {
      if (this._utilisateurId != this._utilisateur?.Id) {
        this._utilisateurId = this._utilisateur?.Id;
        this.utilisateurIdChange.emit(this._utilisateurId);
        this.utilisateurChange.emit(this._utilisateur);
      }
    }
  }

  toggleShowAll(): void {
    this.showAll = !this.showAll;
    this.loadUtilisateurs();
  }
}
